import React, { useState } from 'react'
import { object, string } from "yup";
import * as yup from "yup";

const useModalEmail = () => {
    const [isModalUpdate, setModalUpdate] = useState(false)

    const openModalUpdate = () =>{
        setModalUpdate(true)
    }

    const closedModalUpdate = () =>{
       setModalUpdate(false)
    }

    const validation = object({
      email: yup
      .string()
      .email("Digite um endereço de e-mail válido")
      .required("O email é obrigatório!"),

     });

    const [initial, setInitial] = useState({
      email: "",
   });

  return {
     isModalUpdate,
     setModalUpdate,
     openModalUpdate,
     closedModalUpdate,
     initial,
     setInitial,
     validation
  }
}

export default useModalEmail